export default {
  CUSTOMER_NOTIFICATION_REPOSITORY: Symbol.for('CUSTOMER_NOTIFICATION_REPOSITORY'),
  GET_CUSTOMER_NOTIFICATIONS_QUERY: Symbol.for('GET_CUSTOMER_NOTIFICATIONS_QUERY'),
};
